import { render, staticRenderFns } from "./safesTransfer.vue?vue&type=template&id=d65d1d58"
import script from "./safesTransfer.vue?vue&type=script&lang=js"
export * from "./safesTransfer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports